import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getFilter = createAsyncThunk("users/getFilter", async () => {
  const response = await ahaApi.Account.filter().then((res) => {
    return res;
  });

  return response;
});

export const filterSlice = createSlice({
  name: "filter",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(getFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getFilter.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const filterList = (state) => state&&state.filter&&state.filter.value;
export const filterListLoading = (state) => state&&state.filter&&state.filter.loading;

export default filterSlice.reducer;
